import {debounce} from 'lodash';
import {useMemo, useState} from 'react';
import {daDataService} from '../api/services/daData.service';
import {ToastHelpers} from '../shared/helpers/toastHelpers';
import {DaDataSuggestion} from '../shared/types/daData.types';

export const useDaData = () => {
  const [suggestions, setSuggestions] = useState<DaDataSuggestion[]>([]);

  const fetchSuggestions = useMemo(
    () =>
      debounce(async (query: string) => {
        if (query.length < 1) {
          setSuggestions([]);
          return;
        }

        try {
          const res = await daDataService.getAddressSuggestions(query);
          setSuggestions(res.suggestions);
        } catch (error) {
          ToastHelpers.error(error);
        }
      }, 300),
    [],
  );

  const handleChangeAddress = (newValue: string) => {
    fetchSuggestions(newValue);
  };

  return {
    suggestions,
    handleChangeAddress,
  };
};
